import '@firebase/firestore';
//# sourceMappingURL=index.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./~/firebase/firestore/dist/index.esm.js
// module id = 77
// module chunks = 0